import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { removeMessage } from 'src/actions';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export default function GlobalMessage() {
    const dispatch = useDispatch();

    const propsAlert = useSelector((state) => state.interface.globalMessage);
    const handleSnackbarClose = () => {
        dispatch(removeMessage());
    };

    const { open, severity, message } = propsAlert;

    return (
        <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={handleSnackbarClose}
        >
            {severity !== '' ?
                <Alert onClose={handleSnackbarClose} severity={severity}>
                    {message}
                </Alert>
             : null}
        </Snackbar>
    );
}